<template>
  <div class="card mb-5 mb-xxl-8">
    <!--begin::Content-->

    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
      <!--begin::Container-->

      <div id="kt_content_container" class="container-xxl">
        <div class="flex-lg-row-fluid ">
          <div class="card card-custom">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label">{{ $t('session.list') }}</h3>
              </div>
              <div class="card-toolbar">
                <Select2
                    v-model="boxSelected"
                    :isRequired="false"
                    :multiple="false"
                    :show-search="false"
                    :placeholderText="$t('e-commerce.checkout.status')"
                    :selectClass="'form-select form-select-solid kt_select2 w-200px'"
                    containerClass="d-flex flex-column fv-row me-5 mw-500px"
                    name="box_selected"
                >
                  <option  value="all">{{$t('shop.all_box') }}  </option>
                  <option v-for="box in shopBoxes" :key="box.id" :value="box.id">{{ box.name}}</option>

                </Select2>
                <Select2
                    v-model="userSelected"
                    :isRequired="false"
                    :multiple="false"
                    :show-search="false"
                    :placeholderText="$t('e-commerce.checkout.status')"
                    :selectClass="'form-select form-select-solid kt_select2 w-250px'"
                    containerClass="d-flex flex-column fv-row me-5 mw-500px"
                    name="user_selected"
                >
                  <option  value="all">{{$t('shop.all_user') }}  </option>
                  <option v-for="user in shopUsers" :key="user.user_id" :value="user.user_id">{{ user?.seller?.fullname}}</option>

                </Select2>
                <div session-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
                     class="btn btn-sm btn-light d-flex align-items-center px-4">
                  <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
                  <span class="svg-icon svg-icon-1 ms-2 me-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3"
                            d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                            fill="currentColor" />
                      <path
                          d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                          fill="currentColor" />
                      <path
                          d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                          fill="currentColor" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div class="card-body" style="margin-top: -20px;">
              <table class="table align-middle table-row-bordered " id="kt_datatable_session"
                style="margin-top: 1px !important; cursor:pointer">
                <thead>
                  <tr>
                    <th> {{ $t("session.opened") }}</th>
                    <th> {{ $t("session.closed") }}</th>
                    <th> {{ $t("session.box") }}</th>
                    <th> {{ $t("session.operator") }}</th>
                    <th> {{ $t("session.sales") }} </th>
                    <th>{{ $t("actions") }}</th>
                  </tr>
                </thead>
              </table>
            </div>

          </div>

          <!--end::Card-->

        </div>
      </div>
      <!--end::Container-->
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import { BASE_URL } from "@/services/api";
import {Settings} from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import Select2 from "@/components/Select2";

export default {
  name: "Index",

  components: {
    Select2
  },

  data() {
    return {

      box: '',
      createSession: false,
      currency: '',
      formCreateData: {
        cash_register: 0
      },
      session: {},
      title: 'menu.session',
      breadcrumbs: [
        {
          name: 'navigation.dashboard',
          path: '/admin/dashboard'
        },
        {
          name: 'session.list',
        }
      ],
      openedTime: '',
      startDate: null,
      endDate: null,
      shopUsers: [],
      shopBoxes: [],
      userSelected : 'all',
      boxSelected : 'all'
    }
  },

  watch: {
    '$i18n.locale': function (value) {
      Settings.defaultLocale = value
      this.initDateRange()
      this.initSelect2()
    },

    'startDate': function (value) {
      if (this.startDate) {
        this.fetchSessionDatas()
      }
    },
    'userSelected' : function(value){
      if(value ){
        this.fetchSessionDatas()
      }
    },
    'boxSelected' : function(value){
      if(value ){
        this.fetchSessionDatas()
      }
    },
    '$route.params.id': function(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // les sessions restent celles de l'ancienne boutique consultée.
      if (newId && newId !== oldId) this.initForShop()
    },
  },

  computed: {
    ...mapGetters('session', [
      'currentSession',
      'currentShopBox',

    ]),
    ...mapGetters('user', [
      'currentUser'
    ]),


  },

  async mounted() {

    await this.initForShop()
    $(document).on("click", "#kt_datatable_session .session_view_btn", (e) => {
      let sessionId = e.target.getAttribute('data-id')

        this.$router.push({name: 'session-sales-path', params: {sessionId: sessionId, id: this.$route.params.id}})

    })

  },

  methods: {
    ...mapActions('session', [
      'getSession',
      'getShopBox',
      'openSession',
      'closeSession'
    ]),
    ...mapActions('boxes', [
      'loadBoxes'
    ]),
    ...mapActions('shop', ['getCurrency','getShopUsers','getShopBoxes']),

    ...mapActions('user',[
      'loadUsers'
    ]),

    async initForShop() {
      await this.initDateRange()
      this.initSelect2()
      await this.getSession()
      await this.fetchSessionDatas()
      await this.getShopsBoxesData()
      await this.getShopsUsersData()
      if (this.getUsers && this.getUsers.length) {
        this.userSelected = 'all'
      }
      if (this.getShopBox && this.getShopBox.length) {
        this.boxSelected = 'all'
      }
      let response = await this.getCurrency()
      this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native
    },

    async getShopsBoxesData() {
      let response = await this.getShopBoxes(this.$route.params.id)
      this.shopBoxes = response.data.boxes
    },
    async getShopsUsersData() {
      let response = await this.getShopUsers(this.$route.params.id)
      this.shopUsers = response.data.users

    },

    fetchSessionDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_session").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
          url: BASE_URL + "/get/pos/sessions/datatables" + `?startDate=${this.startDate}&endDate=${this.endDate}&shop=${this.$route.params.id}&user=${this.userSelected}&box=${this.boxSelected}`,
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {

          }
        },
        columns: [{ data: "opened" }, { data: "closed" }, { data: "box_name" }, { data: "operator_name" }, { data: "sales_turnover" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [

          {
            targets: -6,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -4,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },

          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ e.currency +"</span></span>";
            },
          },

          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""
              render+='<button type="button" data-id="'+ e.id +'"   class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 session_view_btn" >' +
                  '<i  data-id="'+ e.id +'"  class="fa fa-eye"></i>' +
                  '</button>'

              return render
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    initSelect2(){
      $(".kt_select2").select2()
      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'user_selected':
            this.userSelected = e.target.value
            break
          case 'box_selected':
            this.boxSelected = e.target.value
            break
          default:
            break;

        }
      })
      $("#kt_select2_status").change((e) => {
        this.status = e.target.value
      })

    },

    async openBox() {
      this.formCreateData.shop_id = this.currentShopBox.shop_id
      this.formCreateData.box_id = this.currentShopBox.box_id

      this.$loading('kt_open_session')
      await this.openSession(this.formCreateData).then((res) => {
        window.toastr.success(this.$t('session.success'))
        this.$stopLoading('kt_open_session')

      }).catch(() => {
        this.$stopLoading('kt_open_session')
      })

    },


    async closeBox() {
      this.$loading('kt_close_session')
      await this.closeSession().then((res) => {
        window.toastr.success(this.$t('session.danger'))
        this.$stopLoading('kt_close_session')
        this.fetchSessionDatas()
      }).catch(() => {
        this.$stopLoading('kt_close_session')
      })

    },

    async initDateRange() {
      this.isReady = false
      let element = document.querySelector('[session-kt-daterangepicker="true"]');
      let start = moment().subtract(7, 'days');
      let end = moment();

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'),i18n.global.t('lu'),i18n.global.t('ma'),i18n.global.t('me'),i18n.global.t('je'),i18n.global.t('ve'),i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'),  i18n.global.t('august'),  i18n.global.t('september'),  i18n.global.t('october'),  i18n.global.t('november'),  i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

        }
      }, this.cb);
      this.cb(start, end);

    },

    cb(start, end) {
      let element = document.querySelector('[session-kt-daterangepicker="true"]');
      let display = element.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

    },

    pad(s) {
      return (s < 10) ? '0' + s : s;
    },

    convertDate(d) {
      return [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate()),].join('-')
    },

    timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },
  }
}
</script>

<style scoped>input[type="text"] {

  background-color: #eaf6f6;

}</style>
